module.exports = __webpack_public_path__ + "static/media/banner-img-2.e4b48cba.png";